
















import { Vue, Prop, Component } from 'vue-property-decorator';

@Component
export default class TextFieldRowReadonlyInput extends Vue {
  @Prop({
    required: false,
    default: 'Label',
  })
  private label!: string;

  @Prop({
    required: false,
    default: '#BDBDBD',
  })
  private labelColor!: string;

  @Prop({
    required: true,
  })
  private value!: string;

  @Prop({
    required: false,
    default: '#333333',
  })
  private valueColor!: string;

  @Prop({
    required: false,
    default: '100%',
  })
  private width!: string;

  @Prop({
    required: false,
    default: '25px',
  })
  private height!: string;

  @Prop({
    required: false,
    default: 'normal',
  })
  private fontWeight!: string;
}
